import {IconSizeProps} from "./types";

export default function TransferIcon({size=40,...props}:IconSizeProps) {
    return <svg width={size} height={size} viewBox="0 0 40 40" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="36" height="36" rx="18" fill="white"/>
        <rect x="2" y="2" width="36" height="36" rx="18" stroke="#F8F8F8" strokeWidth="4"/>
        <path d="M18.666 12.8913L18.666 26.2246L14.666 21.6413" stroke="black" strokeWidth="1.4" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M22.2217 12.8913L22.2217 26.2246L26.2217 21.6413" stroke="black" strokeWidth="1.4"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}